export const SORT_OPTIONS = [
	{ id: "recommendation", labelKey: "sort.types.recommended" },
	{ id: "price_asc", labelKey: "sort.types.price.asc" },
	{ id: "price_desc", labelKey: "sort.types.price.desc" },
	{ id: "rating_desc", labelKey: "sort.types.tripadvisor" },
	{ id: "stars_desc", labelKey: "sort.types.stars" },
];
